import CustomBanner from "@components/CustomBanner";
import { Head } from "vite-react-ssg";
import BannerImage from "@assets/images/Low-fidelity-ui-design.avif";
import { motion } from "framer-motion";
import GetAQuoteButton from "@components/GetAQuoteButton";
import BannerSideImage from "@assets/images/Low-fidelity-ui-design.avif";
import { TiTick } from "react-icons/ti";
import FrostedContainer from "../../../../components/FrostedContainer";

export const Banner = () => {
  return (
    <>
      <Head>
        <title>
          Cross-Platform App Development Company | Fairfax County, VA
        </title>
        <meta
          name="description"
          content="Build once, launch on iOS & Android. Affordable cross-platform apps for small businesses, startups & soloprenuers in Fairfax County, Virginia. Free consultation."
        />
        <link
          rel="canonical"
          href="https://apptalyst.com/cross-platform-app-development"
        />
      </Head>
      <CustomBanner
        bgImg={BannerImage} 
                    customHeight={true}
        className="h-full  "
        BannerImageAlt="A low-fidelity UI/UX design showing the skeleton, important components and work-flow of a website."
        ariaLabel="Cross-Platform Mobile Applications"
      >
                          <FrostedContainer>            

          <motion.h1
            initial={{ opacity: 0, y: 40 }} 
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
            className="text-[30px] md:text-[31px] lg:text-[35px] xl:text-[40px] 2xl:text-[50px] leading-[1.2] font-bold  "
          >
            Cross-Platform Mobile App Development Company in Fairfax County,
            VA{" "}
          </motion.h1>
          <div>
            <p className="text-base leading-[1.625rem] font-semibold text-white ">
              As a leading cross-platform mobile app development company,
              Apptalyst empowers small businesses, startups, and innovative
              solopreneurs to turn ambitious product visions into reality. We
              bridge the gap between concept and launch by building
              high-performance applications that thrive on both iOS and Android
              from a single codebase. By prioritizing technical architecture and
              development speed, we help our clients achieve maximum ROI without
              sacrificing the premium feel users demand. Whether you are
              launching a consumer MVP or a complex IoT solution, our team
              ensures your software is engineered for performance, scalability,
              and long-term success.
            </p>
          </div>
                     </FrostedContainer>            
      </CustomBanner>
    </>
  );
};
